import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userDetailsReducer from './userDetails';
import userReducer from './userDetails/userSlice';
import { combineReducers } from 'redux';

// Combine reducers
const rootReducer = combineReducers({
  userDetails: userDetailsReducer,
  user: userReducer,
});

// Persist config
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['userDetails'], // only persist userDetails slice
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // to avoid non-serializable errors from redux-persist
    }),
});

// Create persistor
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AppDispatch = typeof store.dispatch | any;
